<mat-sidenav-container class="wrapper__out">
  <mat-sidenav
    class="appNav d-print-none"
    #sidenav
    [mode]="isDesktop ? 'side' : 'over'"
    [opened]="isDesktop"
    [disableClose]="isDesktop"
    ngClass.gt-sm="mat-elevation-z6"
  >
    <nav fxLayout="column">
      <div fxFlex fxLayoutAlign="center center" class="sidenav__logo">
        <img alt="logo" src="assets/img/img_scf_logo_txt_black.svg" />
      </div>
      <ng-material-multilevel-menu
        [configuration]="config"
        (menuIsReady)="menuIsReady($event)"
        [items]="appitems"
        (selectedItem)="selectedItem($event)"
      >
      </ng-material-multilevel-menu>
    </nav>
  </mat-sidenav>
  <mat-sidenav-content fxLayout="column">
    <app-header class="appHeader appHeader--sticky" (toggleSidenav)="sidenav.toggle()"></app-header>
    <div class="inner-wrapper">
      <div class="space-blank mt-0">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer class="appFooter"></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
